import {
    BULK_EDIT_COMPANY_VIDEOS_FIELD,
    BulkEditFieldNameEnum,
    BulkUpdateCompaniesFieldsErrorsType,
} from '../../../../service/company/company-type';
import {BulkUpdateCompaniesErrorsType} from '../bulk-edit-companies-type';

function extractErrorMessage(
    error: BulkUpdateCompaniesFieldsErrorsType['field_set'][keyof BulkUpdateCompaniesFieldsErrorsType['field_set']]
): Array<string> | Array<Array<string>> | null {
    if (!error) {
        return null;
    }

    if ('value' in error) {
        return error.value;
    }

    return error;
}

/** Videos share the "Photos and videos" field, so their server errors are shown under it too. */
export function extractFieldServerError(
    serverError: BulkUpdateCompaniesFieldsErrorsType,
    fieldName: BulkEditFieldNameEnum
): Array<string> | Array<Array<string>> | null {
    const fieldError = extractErrorMessage(serverError.field_set[fieldName]);

    if (fieldName !== BulkEditFieldNameEnum.gallery) {
        return fieldError;
    }

    const videosError = extractErrorMessage(serverError.field_set[BULK_EDIT_COMPANY_VIDEOS_FIELD]);

    if (!fieldError || !videosError) {
        return fieldError ?? videosError;
    }

    return [...fieldError, ...videosError] as Array<Array<string>>;
}

export function hasErrors(errors: Partial<BulkUpdateCompaniesErrorsType>): boolean {
    return Object.values(errors).some((error) => {
        if (error === null) {
            return false;
        }

        return Array.isArray(error) && error.some(Boolean);
    });
}

export function hasNonEmptyValue(errors: Partial<BulkUpdateCompaniesErrorsType>): boolean {
    return Object.values(errors).some((error) => {
        if (error === null) {
            return true;
        }

        if (Array.isArray(error)) {
            return error.some((error_) => !error_);
        }

        return true;
    });
}
